import { render, staticRenderFns } from "./average-time-cards.vue?vue&type=template&id=0ddf1051&scoped=true&"
import script from "./average-time-cards.vue?vue&type=script&lang=js&"
export * from "./average-time-cards.vue?vue&type=script&lang=js&"
import style0 from "./average-time-cards.vue?vue&type=style&index=0&id=0ddf1051&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddf1051",
  null
  
)

component.options.__file = "average-time-cards.vue"
export default component.exports